import { useMemo } from 'react';
import * as R from 'ramda';

import EnumMultipleInput from '@atom/components/common/dataTypeInput/EnumMultipleInput';
import { DataType } from '@atom/types/dataType';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import { mapBooleanFilter } from './AttributeFilterUtilities';
import DateRangeFilter from './DateRangeFilter';
import NumberRangeFilter from './NumberRangeFilter';

import classes from './attributeFilterGroup.module.css';

interface Props {
  assetFiltersCart: any;
  onAssetFiltersChange: (
    attributeId: string,
    value: any,
    dataType: DataType,
  ) => void;
  attribute: any;
}

const AttributeFilter = ({
  assetFiltersCart,
  onAssetFiltersChange,
  attribute,
}: Props) => {
  const onChange = (newValue: any) => {
    const mappedValue =
      attribute?.dataType === DataType.BOOLEAN
        ? mapBooleanFilter(newValue, 'out')
        : newValue;

    onAssetFiltersChange(attribute?.id, mappedValue, attribute?.dataType);
  };

  const content = useMemo(() => {
    const { id, dataType, enumeration, unit, name } = attribute;
    const value = R.pathOr(null, [id], assetFiltersCart);

    const props = {
      key: id,
      id,
      value:
        attribute?.dataType === DataType.BOOLEAN
          ? mapBooleanFilter(value, 'in')
          : value,
      options: enumeration,
      label: name,
      onChange,
      unit,
      placeholder: isNilOrEmpty(value) ? 'All' : '',
    };

    const inputs = {
      [DataType.BOOLEAN]: (
        <EnumMultipleInput {...props} options={['Yes', 'No']} />
      ),
      [DataType.DATE]: <DateRangeFilter {...props} />,
      [DataType.NUMBER]: <NumberRangeFilter {...props} />,
      [DataType.CURRENCY]: <NumberRangeFilter {...props} currency />,
      [DataType.ENUM_SINGLE]: <EnumMultipleInput {...props} />,
      [DataType.ENUM_MULTIPLE]: <EnumMultipleInput {...props} />,
    };

    return inputs[dataType] || <div />;
  }, [assetFiltersCart, onAssetFiltersChange, attribute, onChange]);

  return <div className={classes.attributeInputContainer}>{content}</div>;
};

export default AttributeFilter;
